<template lang="html">
	<div class="List">

		<template>
			<vfilter
				template='participants'
				:data='filter'
				@FILTER_CHANGE='onChange'
				@FILTER_CHANGE_PAYLOAD='onChangePayload'
			/>

			<default
				:data='api_response'
				:merge='merge_items'
				:locked='locked'
			/>
		</template>

		<pager
			:total='totalPagesCount'
			:current='currentPageNumber'
			:locked='locked'
			@goto='goto'
			>
			{{loadMoreText}}
		</pager>
	</div>
</template>

<script>
const objectMerge = require('object-merge');

module.exports = {
	name: 'List',

	props: {
		dataParams: {
			type: String,
			required: true
		}
	},

	components: {
		default: require('./lists/default.vue'),
		'vfilter': require('./Filters.vue'),
		pager: require('./Pager.vue')
	},

	data() {
		return {
			api_response: {},
			merge_items: false,
			locked: false,
			request: {},
			filter_payload: {}
		}
	},

	computed: {
		componentParams() {
			let str = this.dataParams.replace(/'/g, '"');
			return JSON.parse(str);
		},

		totalPagesCount() {
			return this.api_response.pager ? this.api_response.pager.total_pages_count : null;
		},

		currentPageNumber() {
			return this.api_response.pager ? this.api_response.pager.current_page_number : null;
		},

		loadMoreText() {
			return this.api_response.pager ? this.api_response.pager.load_more : null;
		},
		filter() {
			return this.api_response.filter ? this.api_response.filter : null;
		}
	},

	methods: {
		loadAPI(payload) {
			this.locked = true;
			// console.log(payload);
			let method = this.componentParams.method;
			let url = this.componentParams.url;
			let custom_request = objectMerge(this.componentParams.request, payload || {}, this.request, this.filter_payload);

			// console.log(custom_request);

			let options = {
				responseType: 'json'
			}

			if(method.toLowerCase() == 'post') {
				// options.params = custom_request;
				// options.body = custom_request;
				options.emulateJSON = true;
				this.$http[method](url, custom_request, options).then(success).catch(error);
			}
			else if(method.toLowerCase() == 'get') {
				options.params = custom_request;
				this.$http[method](url, options).then(success).catch(error);
			}

			function success(response) {
				// console.log(response);
				this.api_response = response.body.api_response;
				this.request = response.body.api_response.request;
				this.locked = false;
			}

			function error(err) {
				// console.log(err);
				this.locked = false;

				switch (err.status) {
					case 0:
						$.fancybox.open(window.YAMASTERS_FRONTEND.translations.ERR_INTERNET_DISCONNECTED);
						break;

					case 404:
						$.fancybox.open(window.YAMASTERS_FRONTEND.translations.ERR_404_NOT_FOUND);
						break;

					default:

				}
			}
		},

		goto(payload) {
			// console.log(`Go to: ${payload}`);

			switch (payload) {
				case 'prev':
					this.merge_items = false;
					this.loadAPI({
						PAGEN_1: this.currentPageNumber - 1
					})
					break;

				case 'next':
					this.merge_items = false;
					this.loadAPI({
						PAGEN_1: this.currentPageNumber + 1
					})
					break;

				case 'merge':
					this.merge_items = true;
					this.loadAPI({
						PAGEN_1: this.currentPageNumber + 1
					})
					break;

				default:
					this.merge_items = false;
					this.loadAPI({
						PAGEN_1: payload
					})
			}
		},

		onChangePayload(payload) {
			console.log(payload);
			this.filter_payload = payload;
			this.merge_items = false;
		},

		onChange(payload) {
			// console.log(payload);
			this.filter_payload = payload;
			this.merge_items = false;

			this.loadAPI();
		}
	},

	beforeMount() {
		this.loadAPI();
	}
}
</script>

<style lang="scss">
	.List{
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// List.vue?111a98be